import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import YoutubeCard from './components/YoutubeCard';


function App() {


  return (
    <div>
      <h1>Lastest Videos</h1>
      <h2>Grabbing the latest 10 videos from my Youtube Channel using React.js</h2>
      <h3>Using Ajax to fetch the lastest videos, using API key and channel ID</h3>
    <YoutubeCard />
    </div>
  );
}

export default App;
